import { MinusIcon, PlusIcon } from "@xola/icons";
import { Skeleton } from "@xola/ui-kit";
import React from "react";

export const QuantitySpinnerSkeleton = ({ text = "" }: { text?: string }) => {
    return (
        <div className="flex items-center justify-center">
            <Skeleton height={42}>
                <div className="flex space-x-3">
                    <ButtonSkeleton isDecrease />
                    <div className="mx-3 min-w-[25px] text-center">
                        <span className="underline">0</span>
                        <div className="leading-none">{text}</div>
                    </div>
                    <ButtonSkeleton isDecrease={false} />
                </div>
            </Skeleton>
        </div>
    );
};

const ButtonSkeleton = ({ isDecrease }: { isDecrease: boolean }) => {
    const icon = isDecrease ? <MinusIcon className="top-0" /> : <PlusIcon className="top-0" />;

    return (
        <div className="inline-flex h-10 items-center justify-center whitespace-nowrap rounded border border-gray-light px-3 py-4 leading-base">
            {icon}
        </div>
    );
};
